import { render, staticRenderFns } from "./indexGeneral.vue?vue&type=template&id=61a379c6&scoped=true"
import script from "./indexGeneral.vue?vue&type=script&lang=js"
export * from "./indexGeneral.vue?vue&type=script&lang=js"
import style0 from "./indexGeneral.vue?vue&type=style&index=0&id=61a379c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a379c6",
  null
  
)

export default component.exports